module.exports = __webpack_public_path__ + "img/AFMS_HARSH_BRK.85afa1e7.png";